module.exports = {"410371001":"瀛洲街道","410371002":"辛店街道","410371003":"徐家营街道","410371101":"丰李镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410371.json
// module id = 1673
// module chunks = 0